<style>

    .loading-mask {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 99999;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
    }

    .loading-mask > div {
        position: absolute !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%);
    }

</style>

<template>
    
    <div class="loading-mask"  v-show="show">
          <div class="sk-spinner sk-spinner-wave">
                                    <div class="sk-rect1"></div>
                                    <div class="sk-rect2"></div>
                                    <div class="sk-rect3"></div>
                                    <div class="sk-rect4"></div>
                                    <div class="sk-rect5"></div>
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            show: {
                default: false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// loading.vue?28ade8b0